export default __webpack_public_path__ + "static/Pãodeacucar-664bb4097b15338f2eb6a8756509e857.png";